import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import { selectors as rootSelectors } from '../root';

import ManualApprove from './components/forms/manual-approve';
import Table from './components/table/main';
import DailyApprovePopup from './components/popups/daily-approve-popup';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content conversions-approve">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Conversions approve')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<ManualApprove {...props} enableReinitialize={true} initialValues={props.manualApproveInitialValues} />
					<Table {...props} />
				</div>
				<DailyApprovePopup {...props}/>
			</div>
		</Animate>
	),
	'manual'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		calendar: selectors.getCalendar(state),
		pagination: selectors.getPagination(state),
		dailyApproveList: selectors.getDailyApproveList(state),
		manualApproveInitialValues: selectors.getManualApproveInitialValues(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		progressBar: selectors.getProgressBar(state),
		showDailyApprovePopup: selectors.getShowDailyApprovePopup(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-approve/main.js